import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';

export default function NavCard() {
  return (
    <Card
      sx={{
        bgcolor: '#313843',
        color: '#fff',
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        p: 1,
        cursor: 'pointer',
        '&:hover': { bgcolor: '#2C2C3D' }
      }}
      elevation={3}
    >
      {/* Left: Icon + Title + Subtitle */}
      <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        {/* Icon */}
        <Box
          sx={{
            mr: 1,
            p: 1,
            borderRadius: 10,
            bgcolor: '#21262D',
            color: '#6090E4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ForumOutlinedIcon />
        </Box>

        {/* Title + Subtitle */}
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="subtitle1" fontWeight={600}>
            Help Center
          </Typography>
          <Typography variant="body2" color="grey.400">
            Answers Here
          </Typography>
        </Box>
      </Box>

      {/* Right: Arrow Icon */}
      <IconButton sx={{ color: '#4D546B' }}>
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </Card>
  );
}
